import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../components/EditLocalNotepad.css";

const API_BASE = "https://newerp.awasthivitality.com/api";

const getToken = () =>
  localStorage.getItem("session_token") ||
  localStorage.getItem("token") ||
  "";

const headers = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${getToken()}`,
  "X-Session-Token": getToken(),
});

const EditLocalNotepad = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    pdn_date: "",
    pdn_time: "",
    pdn_message: "",
  });

  const [loading, setLoading] = useState(false);

  /* -------- Fetch Note -------- */
  useEffect(() => {
    const fetchNote = async () => {
      try {
        setLoading(true);
        const res = await fetch(`${API_BASE}/notes/edit/${id}`, {
          headers: headers(),
        });
        const result = await res.json();

        if (result.success) {
          setFormData({
            pdn_date: result.data.pdn_date || "",
            pdn_time: result.data.pdn_time || "",
            pdn_message: result.data.pdn_message || "",
          });
        }
      } catch {
        alert("Failed to load note");
      } finally {
        setLoading(false);
      }
    };

    fetchNote();
  }, [id]);

  /* -------- Update Note -------- */
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(
        `${API_BASE}/local-daily-notes/edit/${id}`,
        {
          method: "PUT",
          headers: headers(),
          body: JSON.stringify(formData),
        }
      );

      const result = await res.json();

      if (result.success) {
        alert("Note updated successfully");
        navigate("/LocalNotepad");
      } else {
        alert("Update failed");
      }
    } catch {
      alert("Error updating note");
    }
  };

 return (
  <div className="eln-wrapper">
    <div className="eln-card">
      <h2>✏️ Edit Local Notepad</h2>

      {loading ? (
        <p className="eln-loading-text">Loading...</p>
      ) : (
        <form onSubmit={handleSubmit} className="eln-form">
          <div className="eln-form-row">
            <div className="eln-form-group">
              <label>Date</label>
              <input
                type="date"
                value={formData.pdn_date}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    pdn_date: e.target.value,
                  })
                }
                required
              />
            </div>

            <div className="eln-form-group">
              <label>Time</label>
              <input
                type="time"
                value={formData.pdn_time}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    pdn_time: e.target.value,
                  })
                }
              />
            </div>
          </div>

          <div className="eln-form-group">
            <label>Comments</label>
            <textarea
              placeholder="Enter note details..."
              value={formData.pdn_message}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  pdn_message: e.target.value,
                })
              }
              rows="4"
            />
          </div>

          <div className="eln-button-row">
            <button type="submit" className="eln-btn eln-btn-save">
              💾 Update
            </button>

            <button
              type="button"
              className="eln-btn eln-btn-back"
              onClick={() => navigate("/LocalNotepad")}
            >
              ⬅ Back
            </button>
          </div>
        </form>
      )}
    </div>
  </div>
);

};

export default EditLocalNotepad;
